import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { Button } from '@osmosis/tailwind-ui/components/Button';
import { ButtonProps } from '@osmosis/tailwind-ui/components/Button';
import React from 'react';
import { useIntl } from 'react-intl';

type Props = {
  pages: number;
  onSelect: (index: number) => void;
  currentIndex: number;
  buttonProps?: ButtonProps;
};

/**
 * Pagination component with dots.
 */
const Pagination = (props: Props): JSX.Element => {
  const { pages, onSelect, currentIndex, buttonProps } = props;

  const intl = useIntl();

  // Helper to generate pagination button label
  const getPaginationLabel = (pageNum: number) => {
    return intl.formatMessage(
      {
        id: 'learn.notes_section.pagination.page',
        defaultMessage: 'Go to page {page}',
      },
      { page: pageNum + 1 },
    );
  };

  // Nav label for wrapper
  const navLabel = intl.formatMessage({
    id: 'learn.notes_section.pagination.nav',
    defaultMessage: 'Notes pagination',
  });

  return (
    <nav aria-label={navLabel}>
      <Flex className="justify-center overflow-hidden">
        {Array.from({ length: pages }).map((item, i) => {
          const isActive = i === currentIndex;

          return (
            <Button
              data-testid={`pagination-button-${i}`}
              key={i}
              onClick={() => onSelect(i)}
              {...buttonProps}
              className="rounded-full bg-transparent p-2 hover:bg-gray-50 active:bg-gray-100 md:m-2"
              aria-label={getPaginationLabel(i)}
              aria-current={isActive ? 'true' : undefined}
            >
              <Box
                className={`relative h-2.5 w-2.5 ${
                  isActive ? 'border-primary-600' : 'border-gray-400'
                } flex items-center justify-center rounded-full border`}
              >
                <Box
                  className={`absolute ${
                    isActive
                      ? 'bg-primary-600 h-1.5 w-1.5'
                      : 'h-2.5 w-2.5 bg-gray-400'
                  } rounded-full`}
                />
              </Box>
            </Button>
          );
        })}
      </Flex>
    </nav>
  );
};

export default Pagination;
